import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../../service/server/server.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';

@Component({
  selector: 'app-cardex-detaile',
  templateUrl: './cardex-detaile.component.html',
  styleUrls: ['./cardex-detaile.component.scss']
})
export class CardexDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  user_id: number | undefined;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  form1: FormGroup;
  search_array: any = [];
  obj: any;
  type_task: number | undefined;
  creator: number | undefined;
  ref: string | undefined;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<CardexDetaileComponent>, private dialog: MatDialog
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any) {

    this.create_form();
    if (dialog_data) {
      this.ref = dialog_data.ref;
      this.creator = dialog_data.creator;
    }
    if (dialog_data.res) {
      this.form1.patchValue({
        material: dialog_data.res.material,
        material_title: dialog_data.res.material_title,
        user: dialog_data.res.user,
        user_title: dialog_data.res.user_title,
        date1: dialog_data.res.date1,
        date2: dialog_data.res.date2,
        creator: dialog_data.creator,
        ref: dialog_data.ref,
      })
    }
  }//end consructor

  ngOnInit() {
  }

  create_form() {
    this.form1 = new FormGroup({
      'material': new FormControl(null, Validators.pattern('[0-9]{1,}]')),
      'material_title': new FormControl(null),
      'user': new FormControl(null, Validators.pattern('[0-9]{1,}]')),
      'user_title': new FormControl(null),
      'date1': new FormControl(null),
      'date2': new FormControl(null),
    })
  }

  search(excel: number) {
    var date1;
    var date2;
    if (this.form1.value.date1) { date1 = `${this.form1.value.date1.toISOString()}`; }
    if (this.form1.value.date2) { date2 = `${this.form1.value.date2.toISOString()}`; }
    this.obj = {
      'material': this.form1.value.material, 'user': this.form1.value.user
      , 'date1': date1, 'date2': date2
    };
    if (excel == 1) this.router.navigate(['/home', 'cardex', 171], { queryParams: this.obj });
    else {
      this.matDialogRef.close({
        date1: this.form1.value.date1,
        date2: this.form1.value.date2,
        material: this.form1.value.material,
        user: this.form1.value.user,
        export_excel: excel
      })
    }
  }


  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, creator: this.creator }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 171) {
            this.form1.patchValue({
              'material': res.id,
              'material_title': res.title
            })
          }
          if (id == 24) {
            this.form1.patchValue({
              'user': res.id,
              'user_title': res.title
            })
          }
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 26) {
      this.form1.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 24) {
      this.form1.patchValue({
        'user': null,
        'user_title': null
      })
    }
    if (id == 171) {
      this.form1.patchValue({
        'material': null,
        'material_title': null
      })
    }
  }

  close() {
    var obj = {
      'material': this.form1.value.material
      , 'material_title': this.form1.value.material_title
      , 'date1': this.form1.value.date1
      , 'date2': this.form1.value.date2
      , 'user_title': this.form1.value.user_title
      , 'user': this.form1.value.user
    }
    if (this.ref == 'home') this.matDialogRef.close(obj);
    else this.matDialogRef.close();
  }

  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

